// Read-only Xero payroll leave balances shown in the Request leave form (People web and
// the mobile app). Shared so the two surfaces cannot drift apart.

// Only these Xero pay-item leave categories are shown in the Request leave form.
export const LEAVE_BALANCE_LABELS = {
	ANNUALLEAVE: 'Annual leave',
	LONGSERVICELEAVE: 'Long service leave',
};

export const formatLeaveBalanceUnits = (balance) => {
	const rawUnits = balance?.numberOfUnits;
	const number = rawUnits === null || rawUnits === undefined || rawUnits === '' ? Number.NaN : Number(rawUnits);
	const units = String(balance?.typeOfUnits || '').toLowerCase();
	if (!Number.isFinite(number)) {
		return units || 'Not available';
	}
	const formatted = Number.isInteger(number) ? String(number) : String(Number(number.toFixed(2)));
	return units ? `${formatted} ${units}` : formatted;
};

export const getVisibleLeaveBalances = (balances) => (
	(balances || []).filter(balance => LEAVE_BALANCE_LABELS[balance?.leaveCategoryCode])
);
